import axios from '@/libs/api.request'
// 调度中心参数设置
const earlyWarningSet = {
    // 详情
    getEarlyWarningSet: () => {
        return axios.get({
            url: '/EarlyWarningSet'
        })
    },
    // 新增、编辑
    earlyWarningSet: (data) => {
        return axios.post({
            url: '/EarlyWarningSet',
            data: data
        })
    }
}
export default earlyWarningSet


// WEBPACK FOOTER //
// ./src/api/api-earlyWarningSet.js